{
  "app_product.length.one_month": "월정액 플랜",
  "app_product.length.one_year": "연간 할인 플랜",
  "fullscreendropzone.label": "여기에 사진이나 동영상 가져오기",
  "fullscreendropzone.chooseFileButton": "파일 선택하기",
  "uploadfilearea.selectedCount": "{selected} / {all}개 선택 중",
  "uploadfilearea.selectButton": "모두 선택",
  "uploadfilearea.deselectButton": "모두 삭제",
  "loginarea.title": "로그인",
  "loginarea.accountRequired.title": "이메일 주소를 등록해 주세요!",
  "loginarea.accountRequired": "로그인하시려면 이메일 주소와 비밀번호를 등록하셔야 합니다. 아직 등록하지 않으신 경우 패밀리 앨범 앱에서 '가족 설정' 화면의 '이메일 주소 등록'에서 등록해 주시기 바랍니다.",
  "loginarea.emailAddressPlaceholder": "이메일 주소",
  "loginarea.passwordPlaceholder": "비밀번호",
  "loginarea.autoLoginCheckboxLabel": "다음부터 자동으로 로그인",
  "loginarea.loginButton": "로그인",
  "loginarea.forgottenPassword": "{link}",
  "loginarea.forgottenPasswordLinkText": "비밀번호를 잊어버리신 경우",
  "loginotparea.title": "인증코드 입력",
  "loginotparea.description": "등록하신 이메일 주소로 전송된 인증코드를 입력해 주시기 바랍니다.",
  "loginotparea.submit": "전송하기",
  "loginotparea.recreate": "인증코드 재전송",
  "uploaderappbar.onesAlbum": "{name}의 앨범",
  "uploaderappbar.logout": "로그아웃",
  "uploaderappbar.premium": "프리미엄",
  "uploaderappbar.premiumPro": "프리미엄 Pro",
  "uploadprogressdialog.title.uploading": "「{audienceType}」로 업로드 중 - 앞으로 {remaining}개",
  "uploadprogressdialog.title.uploading.description": "※10분 이내의 동영상만 업로드할 수 있습니다.",
  "uploadprogressdialog.title.uploaded": "{numUploaded}개의 업로드가 완료되었습니다.",
  "uploadprogressdialog.title.uploaded.description": "업로드하신 사진과 동영상은 앱 버전에서 확인할 수 있습니다.{br}반영될 때까지 다소 시간이 걸릴 수 있습니다.",
  "uploadprogressdialog.cancel": "업로드 취소하기",
  "uploadprogressdialog.done": "닫기",
  "cancelcompletedialog.body": "업로드를 취소하였습니다.",
  "audienceType.owners_only": "관리자 한정 공개",
  "audienceType.family": "가족 전원 공개",
  "uploadbuttons.owners_only": "관리자 한정 공개",
  "uploadbuttons.owner.family": "가족 전원 공개",
  "uploadbuttons.follower.family": "앨범에 추가",
  "disableuploadmodal.noAlbum": "앨범을 확인할 수 없으니, 다시 참가하실 경우에는 아빠나 엄마의 초대를 받으신 후에 재개해 주시기 바랍니다.",
  "disableuploadmodal.notAllowedFollowerUpload": "업로드 기능이 OFF로 설정되어 있습니다. 이 앨범의 아빠나 엄마가 설정을 변경하시면 업로드할 수 있습니다.",
  "disableuploadmodal.notPremiumOwner": "FamilyAlbum 프리미엄에 등록하시면 이용할 수 있습니다.",
  "disableuploadmodal.notPremiumFollower": "FamilyAlbum 프리미엄에 등록하시면 이용할 수 있습니다. 프리미엄은 이 앨범의 아빠나 엄마 한정으로 등록할 수 있습니다.",
  "fileGridListTile.error.tooLongVideo": "동영상의 길이는 10분까지입니다.",
  "fileGridListTile.error.tooLargeVideo": "동영상의 파일 사이즈는 5GB까지입니다.",
  "fileGridListTile.error.tooLargeImage": "사진의 파일 사이즈는 200MB까지입니다.",
  "fileGridListTile.error.unsupportedVideo": "동영상의 파일 형식은 MP4 / MOV / QT / 3GP / M4V / MTS로 해주시기 바랍니다.",
  "fileGridListTile.error.unsupportedImage": "사진 업로드는 JPG, GIF, PNG, HEIF, HEIC 형식만 가능합니다.",
  "customAudienceTypeButton.title": "공개 범위를 선택해 주시기 바랍니다.",
  "customAudienceTypeButton.description": "공개 범위를 작성하시면, 특정 멤버에게 사진・동영상을 공개할 수 있습니다.{br}공개 범위는 앱 버전에서 작성해 주시기 바랍니다.",
  "fullscreenmodal.notSupportedBrowser.title": "이 웹브라우저는 지원하지 않습니다.",
  "fullscreenmodal.notSupportedBrowser.body": "Google Chrome의 최신 버전을 이용해 주시기 바랍니다.",
  "subscriptionItem.contractStatus.cancelled.message": "{platform}에서 해약 완료",
  "subscriptionItem.contractStatus.cancelled.noPlatform": "해약 완료",
  "subscriptionActions.scheduled.cancelDialog.title": "예약을 취소하시겠습니까?",
  "subscriptionActions.scheduled.cancelDialog.description": "예약을 취소하시면 현재 등록 중인 플랜을 계속해서 이용하실 수 있습니다.",
  "subscriptionActions.scheduled.cancelDialog.cancelButton": "예약 취소하기",
  "subscriptionActions.scheduled.cancelDialog.closeButton": "닫기",
  "premiumSubscriptionTemplate.cancelled.isAppPurchase.message": "앱 내 결제 해약이 완료되었습니다. 계속해서 프리미엄 기능을 이용하시려면 웹 결제를 이용해 주시기 바랍니다.",
  "premiumSubscriptionTemplate.cancelled.isAppPurchase.button.title": "웹 결제로 시작하기",
  "premiumPlan.title": "플랜 선택",
  "premiumPlan.defaultAppealText": "웹 결제 시 연간 최대 {number}% 할인!",
  "premiumPlan.campaignAppealText": "기간 한정 이벤트 실시 중!",
  "premiumPlan.confirmButton": "이 플랜으로 진행",
  "premiumPlan.backButton": "돌아가기",
  "planSelection.premiumPro.title": "프리미엄 Pro",
  "planSelection.premiumPro.description": "모든 프리미엄 기능 이용 플랜",
  "planSelection.premium.title": "프리미엄",
  "planSelection.premium.description": "프리미엄 인기 기능을 모은 기본 플랜",
  "planCard.yearlyPlan": "연간 할인 플랜",
  "planCard.monthlyPlan": "월정액 플랜",
  "planCard.perMonth": "/ 월",
  "planCard.perYear": "/ 연",
  "planCard.subscribed": "등록 중",
  "planCard.monthlyEquivalent": "월 기준",
  "premiumPlansAlbums.confirmAlbumAndPlan": "대상 앨범 및 플랜 확인",
  "premiumPlansAlbums.targetAlbum": "대상 앨범",
  "premiumPlansAlbums.albumLabel": "{albumName}의 앨범",
  "premiumPlansAlbums.pulldown.desctiption.owner": "관리자로 참가 중",
  "premiumPlansAlbums.webPaymentDiscount": "웹 결제 시 연간 최대 {number}% 할인!",
  "premiumPlansAlbums.freeTrialButton": "신규 한정 {months}개월 무료",
  "premiumPlansAlbums.cancelAnytime": "언제든지 취소 가능",
  "premiumPlansAlbums.otherUserSubscribingMessage": "이 앨범은 {userName} 님이 플랜에 등록 중입니다.",
  "premiumPlansAlbums.otherAlbumInAppSubscriptionMessage": "고객님께서는 이미 다른 앨범에 프리미엄을 등록 중이므로 이 앨범에는 등록하실 수 없습니다.",
  "premiumPlansAlbums.proceedToPayment": "결제하기",
  "premiumPlanChange.title": "플랜 변경",
  "premiumPlanChange.confirmButton": "이 플랜으로 변경",
  "premiumPlanChange.backButton": "돌아가기",
  "premiumSubscriptionTemplate.scheduled.currentPlan.title": "등록 중인 플랜",
  "premiumSubscriptionTemplate.scheduled.schedulePlan.title": "변경 예약 중인 플랜",
  "premiumSubscription.title": "등록 중인 플랜",
  "premiumSubscription.multipleSubscriptions.warning.title": "【중요】 프리미엄 플랜이 중복 등록되었습니다.",
  "premiumSubscription.multipleSubscriptions.warning.message": "앱 내 결제로 프리미엄 플랜에 등록되어 있습니다. 이용 중인 App Store 또는 Google Play 스토어에서 해약해 주셔야 합니다.",
  "premiumSubscription.multipleSubscriptions.warning.cancelLink": "해약 방법 보기!",
  "premiumSubscription.empty.message": "현재 등록 중인 플랜이 없습니다.",
  "premiumSubscription.empty.startButton": "프리미엄 시작하기",
  "premiumSubscription.updateInProgress": "플랜 자동 갱신 중입니다.\n1시간 정도 기다려 주시기 바랍니다.",
  "premiumSubscription.switchToWeb.warning.title": "【중요】 웹 결제로 변경하는 방법",
  "premiumSubscription.switchToWeb.warning.message": "중복 결제를 방지하기 위해 반드시 하단의 내용을 확인해 주시기 바랍니다.",
  "premiumSubscription.switchToWeb.warning.step1": "위 '갱신일'로부터 24시간 전까지 앱 내 결제를 해약해 주시기 바랍니다.",
  "premiumSubscription.switchToWeb.warning.step1.link": "해약 방법 보기!",
  "premiumSubscription.switchToWeb.warning.step2": "웹 결제로 변경해 주시기 바랍니다.",
  "premiumSubscription.switchToWeb.warning.note": "위 순서대로 진행하시면, 다음 갱신일부터 웹사이트 결제로 변경됩니다.",
  "premiumSubscription.cancelled.warning": "곧 프리미엄 기능을 이용하실 수 없게 됩니다.",
  "premiumSubscription.cancelled.appPurchase.message": "해약이 완료되었습니다. 계속 이용하시려면 패밀리 앨범 앱에서 재개 신청을 해 주시기 바랍니다.",
  "premiumSubscription.cancelled.webPurchase.message": "해약이 완료되었습니다. 계속 이용하시려면 하단의 버튼을 눌러 재개 신청을 해 주시기 바랍니다.",
  "premiumSubscription.cancelled.webDiscount": "웹 결제 시 연간 최대 {number}% 할인!",
  "premiumPaymentTemplate.appToWebPayment.newPlanStartsDate": "이용 개시일",
  "premiumPaymentTemplate.appToWebPayment.newPlanPaymentDate": "결제일",
  "premiumPaymentTemplate.appToWebPayment.newPlanStartsImmediate": "확정 즉시",
  "premiumPaymentTemplate.appToWebPayment.description": "고객님께서 앱 내에서 결제하신 플랜은 아직 {days}일이 남아 있습니다. 따라서 이번에 등록하신 플랜은 <b>{days}일 동안 요금이 발생하지 않으며</b>, {date}부터 웹 결제가 시작됩니다.",
  "premiumPaymentTemplate.albumTitle": "{albumName}의 앨범",
  "premiumPaymentTemplate.tokushohoInfo.accordionTitle": "이용 개시일 / 결제 / 해약에 관하여'",
  "premiumPaymentTemplate.tokushohoInfo.1": "FamilyAlbum 프리미엄 특전은 등록 후 바로 이용하실 수 있습니다.",
  "premiumPaymentTemplate.tokushohoInfo.2": "개시일로부터 월정액 플랜은 매월, 연간 할인 플랜은 매년 자동 갱신됩니다.",
  "premiumPaymentTemplate.tokushohoInfo.3": "자동 갱신 시 등록하신 결제 방법으로 요금이 청구됩니다.",
  "premiumPaymentTemplate.tokushohoInfo.4": "무료 체험 기간 종료 24시간 전까지 취소하지 않으시면 자동으로 갱신되어 요금이 청구됩니다.",
  "premiumPaymentTemplate.tokushohoInfo.5": "무료 체험 기간 이용은 앨범 1개당 1회에 한합니다.",
  "premiumPaymentTemplate.tokushohoInfo.6": "등록 후 프리미엄 관리 및 해약은 앱 내의 프리미엄 화면에서 설정하실 수 있습니다.",
  "premiumPaymentTemplate.tokushohoInfo.7": "플랜은 언제든지 해약하실 수 있습니다.",
  "premiumPaymentTemplate.tokushohoInfo.8": "해약하셔도 유효기간 중에는 특전을 이용하실 수 있습니다. 결제된 요금은 환불되지 않습니다.",
  "premiumPaymentTemplate.backButton": "돌아가기",
  "webPaymentCampaign.freeTrialExtension.appear.text": "기간 한정 이벤트 실시 중!",
  "webPaymentCampaign.appear.longText": "기간 한정 이벤트 실시 중!\n웹 결제로 혜택 UP!",
  "webPaymentCampaign.freeTrialExtension.button": "2개월간 무료 체험하기",
  "webPaymentCampaign.freeTrialExtension.note": "※결제 개시일 등의 자세한 내용은 다음 화면에서 확인하실 수 있습니다.",
  "webPaymentCampaign.discount.appear.text": "기간 한정 이벤트 실시 중!",
  "webPaymentCampaign.discount.note": "※쿠폰은 다음 화면에서 자동으로 적용됩니다. 실제 결제 금액도 다음 화면에서 확인하실 수 있습니다. 쿠폰은 다음 갱신 시에 한해 적용되며, 이후에는 통상적인 가격으로 청구됩니다.",
  "subscriptionScheduleItem.renewalDate": "갱신일: ",
  "subscriptionItem.expired": "현재 등록 중인 플랜이 없습니다.",
  "subscriptionItem.renewalDate": "갱신일: ",
  "subscriptionItem.expiryDate": "유효기간: ",
  "subscriptionItem.webDiscount": "웹 결제 시 연간 최대 {number}% 할인!",
  "subscriptionItem.switchToWeb": "웹 결제로 변경하기",
  "subscriptionActions.changePlan": "플랜 변경하기",
  "subscriptionActions.managePlan": "플랜 관리",
  "subscriptionActions.cancelSchedule": "예약 취소하기",
  "subscriptionActions.cancelScheduleConfirmTitle": "예약을 취소하시겠습니까?",
  "subscriptionActions.cancelScheduleConfirmBody": "예약을 취소하시면 현재 등록 중인 플랜을 계속해서 이용하실 수 있습니다.",
  "premiumPlanConfirm.title": "갱신 내용 확인",
  "premiumPlanConfirm.targetAlbum": "대상 앨범",
  "premiumPlanConfirm.albumName": "{albumName}의 앨범",
  "premiumPlanConfirm.newPlan": "변경 후 플랜",
  "premiumPlanConfirm.newPlanPrice": "새로운 플랜 가격",
  "premiumPlanConfirm.planChangeDate": "플랜 변경일",
  "premiumPlanConfirm.immediately": "확정 즉시",
  "premiumPlanConfirm.termsDescription": "위 '플랜 변경일'부터 변경된 플랜으로 결제됩니다. 변경 전 플랜의 남은 기간에 해당하는 요금은 일할 계산되며, 변경 후 플랜과의 차액 중 부족한 금액만 청구됩니다. 차액이 남는 경우에는 다음 갱신 시 해당 금액만큼 차감되어 청구됩니다. FamilyAlbum 프리미엄은 플랜 개시일을 기준으로, 월정액 플랜은 매월, 연간 할인 플랜은 매년 자동으로 갱신됩니다. 자동 갱신 시에는 등록하신 결제 방법으로 요금이 청구됩니다. 다음 갱신일 24시간 전까지 해지하지 않으시면, 자동으로 갱신되어 요금이 청구됩니다. 등록 후에는 앱 내 프리미엄 화면에서 프리미엄 플랜 관리 및 해약을 직접 설정하실 수 있습니다. 플랜은 언제든지 해약 가능하며, 해약하셔도 유효기간 중에는 특전을 이용하실 수 있습니다. 단, 이미 결제된 요금은 환불되지 않습니다.",
  "premiumPlanConfirm.confirmButton": "확정하기",
  "premiumPlanConfirm.backButton": "돌아가기",
  "premiumPaymentConfirmation.title": "등록이 완료되었습니다!",
  "premiumPaymentConfirmation.appStoreWarningTitle": "【중요】 앱 내 결제로 등록 중이신 경우",
  "premiumPaymentConfirmation.appStoreWarningText": "앱 내 결제로 등록 중이신 경우 이중으로 요금이 결제됩니다. 고객님께서 직접 앱 내 결제를 해약해 주셔야 합니다.",
  "premiumPaymentConfirmation.cancelHelpLink": "해약 방법 보기!",
  "premiumPaymentConfirmation.planReflectionNote": "※플랜이 적용될 때까지 다소 시간이 걸릴 수 있습니다.",
  "premiumPaymentConfirmation.subscriptionDetailLink": "구독 플랜 보기",
  "premiumPaymentConfirmation.enjoyAppButton": "지금 바로 체험하기✨",
  "premiumPaymentConfirmation.enjoyText": "지금 바로 프리미엄을 체험해 보세요✨",
  "premiumPaymentUnableToSubscribe.openAppButton": "앱 열기",
  "premiumPaymentError.title": "오류가 발생했습니다.",
  "premiumPaymentError.incompleteContract": "아직 등록이 완료되지 않았습니다.",
  "premiumPaymentError.cardError": "카드 정보를 다시 한번 확인하신 후, 플랜에 등록해 주시기 바랍니다.",
  "premiumPaymentError.systemError": "잠시 후에 다시 시도해 주시기 바랍니다.",
  "premiumPaymentError.checkCardInfo": "카드 정보 확인",
  "premiumPaymentError.contactSupport": "문제가 해결되지 않는 경우에는 패밀리 앨범 앱의 '가족 설정' 화면에서 '문의'로 연락해 주시기 바랍니다.",
  "premiumPlansAlbums.appPrice.premium.monthly": "5,900원",
  "premiumPlansAlbums.appPrice.premium.yearly": "59,000원",
  "premiumPlansAlbums.appPrice.pro.monthly": "11,900원",
  "premiumPlansAlbums.appPrice.pro.yearly": "119,000원",
  "subscriptionItem.contractStatus.device.web": "웹에서 등록 중",
  "subscriptionItem.contractStatus.device.app": "{device}에서 등록 중"
}
